import { Component, OnInit } from '@angular/core';
import { FormField } from 'src/app/interfaces/form-field.model';
import { faPencil, faTrash, faPlus, faPrint, faBan } from '@fortawesome/free-solid-svg-icons';
import { SalesmanReceiptService } from 'src/app/services/autopac/salesman-receipt.service';
import { NotifierService } from 'angular-notifier';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-salesman-receipt',
  templateUrl: './salesman-receipt.component.html',
  styleUrls: ['./salesman-receipt.component.css']
})
export class SalesmanReceiptComponent implements OnInit {
  faPencil = faPencil;
  faTrash = faTrash;
  faPlus = faPlus;
  faPrint = faPrint;
  faBan = faBan;
  isSaving = false;
  isSearching = false;
  showDeleteModal = false;
  deleteRemarks = '';
  searchCriteria = 'RefNo';
  transferReceipt = false;
  selectedReceipt: any = null;
  private searchVersion = 0;
  private totalVersion = 0;
  private previousPaymentMode = '';
  private terminals: any[] = [];
  tableReceiptEntries: any[] = [];
  tableReceiptHeaders = [
    { title: 'Contract Number', type: 'data', id: 'ContractNo' },
    { title: 'Receipt Number', type: 'data', id: 'ReceiptNo' },
    { title: 'Receipt Date', type: 'data', id: 'ReceiptDate' },
    { title: "Buyer's NRIC", type: 'data', id: 'Nric' },
    { title: "Buyer's Name", type: 'data', id: 'Name' },
    { title: 'Payment Type', type: 'data', id: 'PaymentType' },
    { title: 'Amount', type: 'data', id: 'Amount' },
    { title: 'Status', type: 'data', id: 'Status' },
    { title: 'Invoice Number', type: 'data', id: 'SalesInvNo' },
    { title: "Buyer's Order Number", type: 'data', id: 'RefNo' },
    { title: 'Action', type: 'edit', id: 'Action' },
  ];
  searchForm: FormField[] = [
    { type: 'text', id: 'RefNo', label: 'Buyer Order Number', value: '' },
    { type: 'text', id: 'ContractNo', label: 'Contract Number', value: '', lock: true },
    { type: 'text', id: 'ChequeNumber', label: 'Cheque Number', value: '', lock: true },
    { type: 'text', id: 'ReceiptNo', label: 'Receipt Number', value: '', lock: true },
  ];
  buyerDetailsForm: FormField[] = [
    { type: 'text', id: 'contractDate', label: 'Contract Date:', lock: true },
    { type: 'text', id: 'refNo', label: "Buyer's Order Number:", lock: true },
    { type: 'text', id: 'invoiceDate', label: 'Invoice Date:', lock: true },
    { type: 'text', id: 'invoiceNumber', label: 'Invoice Number:', lock: true },
    { type: 'text', id: 'Nric', label: 'NRIC No/RCB No/Passport No:', lock: true },
    { type: 'text', id: 'name', label: 'Name:', lock: true },
    { type: 'text', id: 'mobileNumber', label: 'Mobile Number:', lock: true },
    { type: 'text', id: 'address', label: 'Address:', lock: true },
    { type: 'text', id: 'salesConsultant', label: 'Sales Consultant:', lock: true },
  ];
  buyerReceiptForm: FormField[] = [
    { type: 'text', id: 'previousReceiptNumber', label: 'Previous Receipt Number', lock: true },
    { type: 'date', id: 'receiptDate', label: 'Receipt Date (dd/mm/yyyy)', required: true },
    { type: 'date', id: 'transactionDate', label: 'Transaction Date (dd/mm/yyyy)', required: true },
    { type: 'select', id: 'paymentType', label: 'Payment Type', required: true,
      options: ['', 'PARF', 'COE Deposit', 'Customer', 'Salesmen Accessories', 'Additional Road Tax'].map(value => ({ value, display: value || 'Please select' })) },
    { type: 'select', id: 'paymentMode', label: 'Payment Mode', required: true,
      options: [
        { value: '', display: 'Please select' },
        { value: 'Credit Card', display: 'CREDIT CARD' }, { value: 'Cheque', display: 'CHEQUE' },
        { value: 'GIRO', display: 'GIRO' }, { value: 'TT', display: 'TT' },
        { value: 'Nets', display: 'NETS' }, { value: 'Amex', display: 'AMEX' },
        { value: 'Cash', display: 'CASH' }, { value: "CASHIER'S ORDER", display: "CASHIER'S ORDER" },
        { value: 'Online Credit Card', display: 'ONLINE CREDIT CARD' },
        { value: 'PNOW', display: 'PAYNOW' }, { value: 'Others', display: 'OTHERS' }
      ] },
    { type: 'text', id: 'issuer', label: 'Issuer' },
    { type: 'text', id: 'bank', label: 'Bank', required: true },
    { type: 'text', id: 'chequeNumber', label: 'Cheque Number' },
    { type: 'select', id: 'terminalNumber', label: 'Terminal Number', options: [] },
    { type: 'text', id: 'batchNumber', label: 'Batch Number', maxLength: 6 },
    { type: 'text', id: 'invoiceNumber', label: 'Invoice Number', maxLength: 6 },
    { type: 'text', id: 'description', label: 'Description' },
    { type: 'number', id: 'amount', label: 'Amount', min: 0, step: 0.01, required: true },
    { type: 'text', id: 'totalPayment', label: 'Total Payment', lock: true },
    { type: 'text', id: 'amountInWords', label: '', lock: true },
    { type: 'select', id: 'status', label: 'Status', required: true,
      options: ['', 'Banked', 'Re-Banked', 'Cleared', 'Cheque Returned', 'Receipt Cancelled'].map(value => ({ value, display: value || 'Please select' })) },
  ];
  transferForm: FormField[] = [
    { type: 'text', id: 'TransferContractNo', label: 'Transfer To Contract Number:', required: true },
    { type: 'text', id: 'TransferRemarks', label: 'Remarks:' },
  ];

  get receiptColumns(): FormField[][] {
    const columns = [
      ['previousReceiptNumber', 'transactionDate', 'paymentMode', 'bank', 'terminalNumber', 'invoiceNumber', 'amount', 'status'],
      ['receiptDate', 'paymentType', 'issuer', 'chequeNumber', 'batchNumber', 'description', 'totalPayment'],
    ];
    return columns.map(ids => ids.map(id => this.buyerReceiptForm.find(field => field.id === id)!)
      .filter(field => field.show !== false));
  }
  get receiptAmountInWords(): string {
    return this.value(this.buyerReceiptForm, 'amountInWords');
  }
  trackReceiptColumn(index: number): number {
    return index;
  }
  trackReceiptField(_index: number, field: FormField): string {
    return field.id;
  }
  updateReceiptField(field: FormField, value: any): void {
    field.value = value;
    this.updateDetails({ fields: this.buyerReceiptForm, updatedValue: this.buyerReceiptForm.findIndex(item => item.id === field.id) });
  }

  constructor(private service: SalesmanReceiptService, private notifier: NotifierService) {}

  ngOnInit(): void {
    this.service.getTerminalList().subscribe({
      next: response => {
        this.terminals = Array.isArray(response.body) ? response.body : [];
        this.configurePaymentMode(false);
      }, error: error => this.reportError(error),
    });
    this.loadLastReceiptNo();
  }

  private value(form: FormField[], id: string): any {
    return form.find(field => field.id === id)?.value ?? '';
  }
  private setValue(form: FormField[], id: string, value: any): void {
    const field = form.find(item => item.id === id);
    if (field) field.value = value ?? '';
  }
  private succeeded(response: any): boolean {
    if (response.code === 0 && response.statusCode >= 200 && response.statusCode < 300) return true;
    this.notifier.notify('error', response.message || 'The operation was not completed');
    return false;
  }
  private reportError(error: any): void {
    this.notifier.notify('error', error?.message || 'The operation was not completed');
  }
  private loadLastReceiptNo(): void {
    this.service.getLastReceiptNo().subscribe({
      next: response => this.setValue(this.buyerReceiptForm, 'previousReceiptNumber', response.body),
      error: error => this.reportError(error),
    });
  }
  onSearchCriteriaChange(): void {
    this.searchForm = this.searchForm.map(field => ({ ...field, lock: field.id !== this.searchCriteria }));
  }
  updateSearchReceipt(event: any): void { this.searchForm = event.fields; }
  searchBuyers(): void {
    const criteria: Record<string, string> = { RefNo: 'BuyerOrderNo', ContractNo: 'ContractNo', ChequeNumber: 'ChequeNo', ReceiptNo: 'ReceiptNo' };
    const text = String(this.value(this.searchForm, this.searchCriteria)).trim();
    if (text) this.search(text, criteria[this.searchCriteria]);
  }
  private search(text: string, criteria: string): void {
    const version = ++this.searchVersion;
    this.isSearching = true;
    this.service.getReceiptBySearch(text, criteria).pipe(finalize(() => {
      if (version === this.searchVersion) this.isSearching = false;
    })).subscribe({
      next: response => {
        if (version !== this.searchVersion || !this.succeeded(response)) return;
        const receipt = response.body;
        this.selectedReceipt = null;
        this.cancelTransfer();
        this.buyerReceiptForm = this.buyerReceiptForm.map(field => ({ ...field, value: '' }));
        const buyerMap: Record<string, string> = { contractDate: 'ContractDate', refNo: 'RefNo', invoiceDate: 'InvoiceDate', invoiceNumber: 'InvoiceNo', Nric: 'Nric', name: 'Name', mobileNumber: 'MobileNumber', address: 'Address', salesConsultant: 'SalesConsultant' };
        this.buyerDetailsForm = this.buyerDetailsForm.map(field => ({ ...field, value: receipt[buyerMap[field.id]] ?? '' }));
        this.searchForm = this.searchForm.map(field => ({ ...field, value: receipt[field.id] ?? '' }));
        this.setValue(this.buyerReceiptForm, 'receiptDate', this.formatDateToInput(receipt.ReceiptDate));
        this.setValue(this.buyerReceiptForm, 'previousReceiptNumber', receipt.PreviousReceiptNo);
        this.setValue(this.buyerReceiptForm, 'issuer', receipt.Issuer);
        this.setValue(this.buyerReceiptForm, 'totalPayment', receipt.TotalPayment);
        this.configurePaymentMode(false);
        this.loadReceiptList(receipt.ContractNo, version);
      }, error: error => { if (version === this.searchVersion) this.reportError(error); },
    });
  }
  private loadReceiptList(contractNo: string, version: number): void {
    this.tableReceiptEntries = [];
    if (!contractNo) return;
    this.service.getReceiptList(contractNo).subscribe({
      next: response => {
        if (version === this.searchVersion) this.tableReceiptEntries = Array.isArray(response.body) ? response.body : [];
      }, error: error => { if (version === this.searchVersion) this.reportError(error); },
    });
  }
  formatDateToInput(value: string): string {
    if (!value || value === '01/01/1900') return '';
    const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value);
    return match ? `${match[3]}-${match[2].padStart(2, '0')}-${match[1].padStart(2, '0')}` : '';
  }
  editReceipt(entry: any): void {
    if (this.isSaving || this.isSearching) return;
    this.selectedReceipt = entry;
    const map: Record<string, string> = { receiptDate: 'ReceiptDate', transactionDate: 'TransactionDate', paymentType: 'PaymentType', paymentMode: 'PayType', issuer: 'Issuer', bank: 'Bank', chequeNumber: 'ChequeNumber', terminalNumber: 'TerminalNumber', batchNumber: 'BatchNumber', invoiceNumber: 'InvoiceNumber', description: 'Description', amount: 'Amount', status: 'Status' };
    this.buyerReceiptForm = this.buyerReceiptForm.map(field => {
      let value = map[field.id] ? entry[map[field.id]] : field.value;
      if (field.type === 'date') value = this.formatDateToInput(value);
      if (field.id === 'paymentMode') value = this.buyerReceiptForm.find(item => item.id === 'paymentMode')?.options?.find(option => String(option.value).toUpperCase() === String(value).toUpperCase())?.value ?? '';
      if (field.id === 'terminalNumber') value = value == null ? '' : String(value);
      return { ...field, value: value ?? '' };
    });
    this.setValue(this.searchForm, 'ReceiptNo', entry.ReceiptNo);
    this.setValue(this.searchForm, 'ContractNo', entry.ContractNo);
    if (entry.RefNo) {
      this.setValue(this.searchForm, 'RefNo', entry.RefNo);
      this.setValue(this.buyerDetailsForm, 'refNo', entry.RefNo);
    }
    this.configurePaymentMode(false);
    this.updateAmount();
  }
  updateDetails(event: any): void {
    this.buyerReceiptForm = event.fields;
    const changed = this.buyerReceiptForm[event.updatedValue]?.id;
    if (changed === 'paymentMode') this.configurePaymentMode(true);
    if (changed === 'amount') this.updateAmount();
  }
  private configurePaymentMode(changed: boolean): void {
    const mode = this.value(this.buyerReceiptForm, 'paymentMode');
    const type: Record<string, string> = { 'Credit Card': 'VISA/MASTER', Amex: 'AMEX', Nets: 'NETS' };
    const terminal = this.buyerReceiptForm.find(field => field.id === 'terminalNumber')!;
    terminal.options = [{ value: '', display: 'Please select' }, ...this.terminals.filter(item => item.PaymentType === type[mode]).map(item => ({ value: String(item.TerminalNo), display: `${item.TerminalNo} (${item.Branch})` }))];
    const cardMode = ['Credit Card', 'Nets', 'Amex'].includes(mode);
    const onlineCard = mode === 'Online Credit Card';
    const visibility: Record<string, boolean> = {
      terminalNumber: cardMode,
      batchNumber: cardMode || onlineCard,
      invoiceNumber: cardMode || onlineCard,
      chequeNumber: !!mode && !['Cash', 'Online Credit Card'].includes(mode),
    };
    for (const [id, visible] of Object.entries(visibility)) {
      const field = this.buyerReceiptForm.find(item => item.id === id)!;
      field.show = visible;
      field.required = id !== 'chequeNumber' && visible;
      if (!visible) field.value = '';
    }
    const bank = this.buyerReceiptForm.find(field => field.id === 'bank')!;
    bank.lock = mode === 'Cash';
    if (changed && mode !== this.previousPaymentMode) {
      terminal.value = '';
      bank.value = mode === 'Amex' ? 'AMEX' : mode === 'Nets' ? 'NETS' : mode === 'Cash' ? 'CASH' : mode === 'Credit Card' ? bank.value : '';
    }
    this.previousPaymentMode = mode;
    this.buyerReceiptForm = [...this.buyerReceiptForm];
  }
  private updateAmount(): void {
    const amount = Number(this.value(this.buyerReceiptForm, 'amount'));
    this.setValue(this.buyerReceiptForm, 'amountInWords', Number.isFinite(amount) && amount >= 0 && this.value(this.buyerReceiptForm, 'amount') !== '' ? this.numberToWords(amount) : '');
    const contract = this.value(this.searchForm, 'ContractNo');
    const version = ++this.totalVersion;
    const searchVersion = this.searchVersion;
    if (!contract) return;
    this.service.getTotalAmount(this.selectedReceipt?.ReceiptNo || '', contract).subscribe({
      next: response => {
        if (version !== this.totalVersion || searchVersion !== this.searchVersion || !this.succeeded(response)) return;
        this.setValue(this.buyerReceiptForm, 'totalPayment', Number(response.body) + (Number.isFinite(amount) ? amount : 0));
        this.buyerReceiptForm = [...this.buyerReceiptForm];
      }, error: error => { if (version === this.totalVersion) this.reportError(error); },
    });
  }
  numberToWords(amount: number): string {
    const units = ['', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN', 'ELEVEN', 'TWELVE', 'THIRTEEN', 'FOURTEEN', 'FIFTEEN', 'SIXTEEN', 'SEVENTEEN', 'EIGHTEEN', 'NINETEEN'];
    const tens = ['', '', 'TWENTY', 'THIRTY', 'FORTY', 'FIFTY', 'SIXTY', 'SEVENTY', 'EIGHTY', 'NINETY'];
    const words = (n: number): string => {
      if (n === 0) return 'ZERO';
      if (n < 20) return units[n];
      if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + words(n % 10) : '');
      if (n < 1000) return words(Math.floor(n / 100)) + ' HUNDRED' + (n % 100 ? ' ' + words(n % 100) : '');
      for (const [scale, label] of [[1e12, 'TRILLION'], [1e9, 'BILLION'], [1e6, 'MILLION'], [1e3, 'THOUSAND']] as [number, string][]) {
        if (n >= scale) return words(Math.floor(n / scale)) + ' ' + label + (n % scale ? ' ' + words(n % scale) : '');
      }
      return '';
    };
    const cents = Math.round(amount * 100);
    return words(Math.floor(cents / 100)) + (cents % 100 ? ' AND ' + (cents % 100 > 9 ? 'CENTS ' : 'CENT ') + words(cents % 100) : '') + ' ONLY.';
  }
  private buildPayload(update = true): any {
    const date = (id: string) => {
      const value = this.value(this.buyerReceiptForm, id);
      return value ? value.split('-').reverse().join('/') : null;
    };
    const terminal = this.visibleReceiptValue('terminalNumber');
    const invoiceNo = this.value(this.buyerDetailsForm, 'invoiceNumber');
    const amountWords = this.value(this.buyerReceiptForm, 'amountInWords');
    const model: any = {
      __type: 'KAPS.Model.CrmSalesmanReceipt',
      ReceiptNo: update ? (this.selectedReceipt?.ReceiptNo || this.value(this.searchForm, 'ReceiptNo') || null) : null,
      ContractNo: this.value(this.searchForm, 'ContractNo'), RefNo: this.value(this.buyerDetailsForm, 'refNo'),
      ContractDate: this.value(this.buyerDetailsForm, 'contractDate'),
      InvoiceDate: this.value(this.buyerDetailsForm, 'invoiceDate'),
      InvoiceNo: invoiceNo === '' ? null : Number(invoiceNo),
      Nric: this.value(this.buyerDetailsForm, 'Nric'), Name: this.value(this.buyerDetailsForm, 'name'),
      MobileNumber: this.value(this.buyerDetailsForm, 'mobileNumber'),
      Address: this.value(this.buyerDetailsForm, 'address'),
      SalesConsultant: this.value(this.buyerDetailsForm, 'salesConsultant'),
      PreviousReceiptNo: this.value(this.buyerReceiptForm, 'previousReceiptNumber') || null,
      ReceiptDate: date('receiptDate'), TransactionDate: date('transactionDate'),
      TerminalNumber: null,
      TerminalNo: terminal && /^\d+$/.test(terminal) ? Number(terminal) : terminal || null,
      Amount: Number(this.value(this.buyerReceiptForm, 'amount')),
      AmountInWords: null,
      AmountWorld: amountWords ? ` ${amountWords}` : null,
      TotalPayment: this.value(this.buyerReceiptForm, 'totalPayment') === '' ? null : Number(this.value(this.buyerReceiptForm, 'totalPayment')),
      CancelReason: update ? this.selectedReceipt?.CancelReason ?? null : null,
      CustomerCode: null,
    };
    for (const [key, id] of Object.entries({ PaymentType: 'paymentType', PaymentMode: 'paymentMode', Issuer: 'issuer', Bank: 'bank', ChequeNumber: 'chequeNumber', BatchNumber: 'batchNumber', InvoiceNumber: 'invoiceNumber', Description: 'description', Status: 'status' })) model[key] = this.visibleReceiptValue(id) || null;
    return model;
  }
  private visibleReceiptValue(id: string): string {
    const field = this.buyerReceiptForm.find(item => item.id === id);
    return field?.show === false ? '' : String(field?.value ?? '');
  }
  isReceiptValid(): boolean {
    if (!String(this.value(this.searchForm, 'ContractNo')).trim() ||
        !String(this.value(this.buyerDetailsForm, 'refNo')).trim()) return false;
    return this.isReceiptFormValid();
  }
  private isReceiptFormValid(): boolean {
    if (this.buyerReceiptForm.some(field => field.required && !String(field.value ?? '').trim())) return false;
    for (const id of ['receiptDate', 'transactionDate']) {
      const date = String(this.value(this.buyerReceiptForm, id));
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return false;
      const parsed = new Date(date + 'T00:00:00Z');
      if (!Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date) return false;
    }
    const amount = Number(this.value(this.buyerReceiptForm, 'amount'));
    if (!Number.isFinite(amount) || amount < 0 || Math.abs(amount * 100 - Math.round(amount * 100)) > 0.000001) return false;
    for (const field of this.buyerReceiptForm) {
      if (field.show === false) continue;
      const value = String(field.value ?? '');
      if (field.maxLength && value.length > field.maxLength) return false;
      if (field.type === 'select' && value && !field.options?.some(option => String(option.value) === value)) return false;
    }
    return true;
  }
  private saveReceipt(update: boolean): void {
    if (this.isSaving || this.isSearching) return;
    const model = this.buildPayload(update);
    if (update && !model.ReceiptNo) { this.notifier.notify('warning', 'Please enter receipt number!'); return; }
    if (!model.ContractNo) { this.notifier.notify('warning', 'Please enter contract number!'); return; }
    if (!model.RefNo) { this.notifier.notify('warning', 'Please enter buyer order number!'); return; }
    if (!this.isReceiptValid()) {
      this.notifier.notify('warning', 'Please complete all required fields with valid values'); return;
    }
    this.isSaving = true;
    (update ? this.service.updateReceipt(model) : this.service.addReceipt(model)).pipe(finalize(() => this.isSaving = false)).subscribe({
      next: response => {
        if (!this.succeeded(response)) return;
        this.notifier.notify('success', response.message);
        this.search(model.ContractNo, 'ContractNo');
      }, error: error => this.reportError(error),
    });
  }
  addReceipt(): void { this.saveReceipt(false); }
  updateReceipt(): void {
    // V1 keeps Update enabled, but only invokes updateItem when the form is valid.
    if (!this.isReceiptFormValid()) return;
    this.saveReceipt(true);
  }
  deleteReceipt(): void {
    if (!this.value(this.searchForm, 'ReceiptNo')) { this.notifier.notify('warning', 'Please input Receipt Number!'); return; }
    this.deleteRemarks = '';
    this.showDeleteModal = true;
  }
  confirmDeleteReceipt(): void {
    if (this.isSaving || !this.deleteRemarks.trim()) return;
    const receipt = this.value(this.searchForm, 'ReceiptNo');
    const contract = this.value(this.searchForm, 'ContractNo');
    this.isSaving = true;
    this.service.deleteReceipt(receipt, this.deleteRemarks).pipe(finalize(() => this.isSaving = false)).subscribe({
      next: response => {
        if (!this.succeeded(response)) return;
        this.notifier.notify('success', response.message);
        this.cancelDelete();
        this.search(contract, 'ContractNo');
      }, error: error => this.reportError(error),
    });
  }
  cancelDelete(): void { this.deleteRemarks = ''; this.showDeleteModal = false; }
  clearReceipt(): void {
    ++this.searchVersion;
    ++this.totalVersion;
    this.isSearching = false;
    this.selectedReceipt = null;
    this.tableReceiptEntries = [];
    for (const form of [this.searchForm, this.buyerDetailsForm, this.buyerReceiptForm]) for (const field of form) field.value = '';
    this.searchForm = [...this.searchForm];
    this.buyerDetailsForm = [...this.buyerDetailsForm];
    this.cancelTransfer();
    this.configurePaymentMode(false);
  }
  printReceipt(): void {
    const receipt = this.value(this.searchForm, 'ReceiptNo');
    if (!receipt) { this.notifier.notify('error', 'Please input Receipt Number To Print!'); return; }
    this.isSaving = true;
    this.service.printReceipt(receipt, this.value(this.searchForm, 'ContractNo')).pipe(finalize(() => this.isSaving = false)).subscribe({
      next: response => {
        if (response.body?.Name) window.open(response.body.Name, '_blank');
        else this.notifier.notify('error', response.message || 'Error printing receipt');
      }, error: error => this.reportError(error),
    });
  }
  updateTransfer(event: any): void { this.transferForm = event.fields; }
  cancelTransfer(): void {
    this.transferReceipt = false;
    this.transferForm = this.transferForm.map(field => ({ ...field, value: '' }));
  }
  transferItem(): void {
    if (this.isSaving || !this.selectedReceipt) return;
    const contract = String(this.value(this.transferForm, 'TransferContractNo')).trim();
    if (!contract) { this.notifier.notify('warning', 'Please input Contract Number to transfer the receipt!'); return; }
    this.isSaving = true;
    this.service.transferReceipt({ ReceiptNo: this.selectedReceipt.ReceiptNo, TransferContractNo: contract, TransferRemarks: this.value(this.transferForm, 'TransferRemarks') }).pipe(finalize(() => this.isSaving = false)).subscribe({
      next: response => {
        if (!this.succeeded(response)) return;
        this.notifier.notify('success', response.message);
        this.search(this.value(this.searchForm, 'ContractNo'), 'ContractNo');
      }, error: error => this.reportError(error),
    });
  }
}
